import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GoogleMeet from './icon-google-meet.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GoogleMeet {...validProps} />;
}
SvgComponent.iconName = 'googleMeet';

/**
 * @deprecated This is a legacy icon
 */
export const GoogleMeetIcon = svgIconWrapper(SvgComponent);
